import { Folder } from '../../core/model/study.model'

export interface AdminDialogData {
  data: Record<string, string | number>
  columns: ColumnFormat
  component: number
  optionsMap: Record<string, DropdownOptions[]>
}

export interface ColumnData {
  actual: string[]
  display: string[]
}

export interface DropdownOptions {
  display: string
  value: string
}

export interface LookupObject {
  value: string
  display: string
}

export interface CarrierUserExport {
  carrier: {
    id: string
    name: string
  }
  users: any[]
}

export interface UserData {
  id: number
  first_name: string
  email_id: string
  last_name: string
  sage_logical_role: string | null
}

export interface YearData {
  id: number
  year: number
  carrer_id: number
}

export interface ColumnFormat {
  actual: string[]
  display: string[]
}

export interface StudyData {
  id: number
  carrier_year_id: number
  name: string
  description: string
  opportunity_id?: string
  folders: Folder[]
}

export interface ProgramData {
  id: string
  studyID: string
  label: string
  programType: string
  grossPortfolioID: string
  cededPortfolioID: string
  netPortfolioID: string
  parentGrossPortfolioID?: string
  analysisID: string
}

export interface DialogResult {
  data: DialogResultData
  event: string
}

export interface DialogResultData {
  values: DialogResultValues
  component: number
  formData: any
}

export interface DialogResultCR {
  name: string
  eps_volatility: string
  esp_volatility_sector: string
  intercept: string
  prospective_roe: string
  roe_sector: string
  executive_summary: string
  eula: string
  tax_rate: string
  surplus: string
  roe_target: string
  book_value: string
}
export interface DialogResultValues {
  name: string
  id: number
  eps_volatility: string
  esp_volatility_sector: string
  intercept: string
  prospective_roe: string
  roe_sector: string
  executive_summary: string
  eula: string
  tax_rate: string
  surplus: string
  roe_target: string
  book_value: string
  year?: string
  carrier_id?: string
  carrier_year_id?: number
  description?: string
  email_id: string
  first_name: string
  last_name: string
  sage_logical_role: string
  reinsurer_id?: string
}

export interface PermissionData {
  granted: boolean
  carrier_id: number | null
  role_id: number
  sage_functionality_id: number
  security_id: number
  sage_functionality_name: string
}

export interface PermissionAction {
  sage_functionality_id: number
  security_id: number
  granted: boolean
}

export interface FacRelationshipData {
  peer_user_id: number
  peer_user_id_name: string
  granted: boolean
}

export enum UserColumn {
  Id = 'id',
  FirstName = 'first_name',
  LastName = 'last_name',
  EmailId = 'email_id',
  SageLogicalRole = 'sage_logical_role',
  Action = 'action',
  Client = 'carrier_id',
  Reinsurer = 'reinsurer_id',
}

export enum UserColumnLabel {
  Id = 'ID',
  FirstName = 'First Name',
  LastName = 'Last Name',
  EmailId = 'Email',
  SageLogicalRole = 'Sage Role',
  Action = '',
  Client = 'Client',
  Reinsurer = 'Reinsurer',
}

// TODO: Add enums for other admin tabs
export const USER_COLUMNS: ColumnFormat = {
  actual: [
    UserColumn.Id,
    UserColumn.FirstName,
    UserColumn.LastName,
    UserColumn.EmailId,
    UserColumn.SageLogicalRole,
    UserColumn.Action,
  ],
  display: [
    UserColumnLabel.Id,
    UserColumnLabel.FirstName,
    UserColumnLabel.LastName,
    UserColumnLabel.EmailId,
    UserColumnLabel.SageLogicalRole,
    UserColumnLabel.Action,
  ],
}

export enum UserRoles {
  Actuary = 'Actuary',
  Analytics = 'Analytics',
  Broker = 'Broker',
  BrokerFac = 'Broker Fac',
  Client = 'Client',
  Contractor = 'Contractor',
  Executive = 'Executive',
  Operations = 'Operations',
  Reinsurer = 'Reinsurer',
}

export const USER_ROLE_OPTIONS: DropdownOptions[] = [
  { display: UserRoles.Actuary, value: UserRoles.Actuary },
  { display: UserRoles.Analytics, value: UserRoles.Analytics },
  { display: UserRoles.Broker, value: UserRoles.Broker },
  { display: UserRoles.BrokerFac, value: UserRoles.BrokerFac },
  { display: UserRoles.Client, value: UserRoles.Client },
  { display: UserRoles.Contractor, value: UserRoles.Contractor },
  { display: UserRoles.Executive, value: UserRoles.Executive },
  { display: UserRoles.Operations, value: UserRoles.Operations },
  { display: UserRoles.Reinsurer, value: UserRoles.Reinsurer },
]

export const INTERNAL_ROLES: Set<UserRoles> = new Set([UserRoles.Broker, UserRoles.Contractor])
